import {
  loadPenRecords,
  mergePenRecords,
  PEN_RECORDS_UPDATED_EVENT,
  savePenRecords
} from '@/utils/penRecords'

const state = {
  installed: false,
  uid: null,
  records: [],
  loaded: false,
  loadPromise: null
}

function safeJsonParse(value, fallback) {
  try {
    return value ? JSON.parse(value) : fallback
  } catch (error) {
    return fallback
  }
}

export function getCurrentUserId() {
  const appuser = safeJsonParse(localStorage.getItem('appuser'), {})
  return appuser && appuser.id
}

function reset(uid) {
  state.uid = uid || null
  state.records = []
  state.loaded = false
  state.loadPromise = null
}

export async function ensurePenRecords() {
  const uid = getCurrentUserId()
  if (String(state.uid || '') !== String(uid || '')) reset(uid)
  if (!uid || state.loaded) return state.records

  if (!state.loadPromise) {
    state.loadPromise = loadPenRecords(uid)
      .then(records => {
        state.records = mergePenRecords(records, state.records)
        state.loaded = true
        return state.records
      })
      .finally(() => {
        state.loadPromise = null
      })
  }
  return state.loadPromise
}

export async function persistPenRecords(records, penType) {
  await ensurePenRecords()
  const mergedRecords = mergePenRecords(state.records, records)
  if (JSON.stringify(mergedRecords) === JSON.stringify(state.records)) return state.records

  const savedRecords = await savePenRecords(getCurrentUserId(), mergedRecords, { penType })
  state.records = mergePenRecords(state.records, savedRecords)
  state.loaded = true
  return state.records
}

function handlePublishedRecords(event) {
  const detail = (event && event.detail) || {}
  if (!Array.isArray(detail.insulinRecordList)) return
  const uid = detail.uid || getCurrentUserId()
  if (String(uid || '') !== String(getCurrentUserId() || '')) return

  state.uid = uid || null
  state.records = mergePenRecords(state.records, detail.insulinRecordList)
  state.loaded = true
}

function refreshRecords() {
  ensurePenRecords().catch(error => {
    console.log('pen records preload failed', error)
  })
}

export function installPenRecordStore() {
  if (state.installed || typeof window === 'undefined') return
  state.installed = true
  window.addEventListener(PEN_RECORDS_UPDATED_EVENT, handlePublishedRecords)
  window.addEventListener('tr-appuser-updated', refreshRecords)
  refreshRecords()
}
